const lessonDays = [
  { day: "Sun", date: "6" },
  { day: "Mon", date: "7" },
  { day: "Tue", date: "8" },
  { day: "Wed", date: "9", lessons: ["Wednesday Beginner"] },
  {
    day: "Thu",
    date: "10",
    lessons: ["Thursday · 4:30", "Thursday · 5:30", "Thursday · 6:30"],
  },
  { day: "Fri", date: "11" },
  { day: "Sat", date: "12" },
];

const staffDays = [
  { day: "Monday", date: "Sep 28" },
  { day: "Tuesday", date: "Sep 29" },
  { day: "Wednesday", date: "Sep 30", shift: true },
  { day: "Thursday", date: "Oct 1" },
  { day: "Friday", date: "Oct 2", shift: true },
  { day: "Saturday", date: "Oct 3" },
  { day: "Sunday", date: "Oct 4" },
];

function ProductFigure({ className = "", label, caption, children }) {
  return (
    <figure className={`br-product-figure ${className}`.trim()}>
      <div className="br-product-window" role="img" aria-label={label}>
        <div aria-hidden="true">{children}</div>
      </div>
      {caption ? <figcaption>{caption}</figcaption> : null}
    </figure>
  );
}

function ProductBar({ product, view }) {
  return (
    <div className="br-product-bar">
      <span className="br-product-brand">BarnRelay</span>
      <span className="br-product-app">{product}</span>
      <span className="br-product-view">{view}</span>
    </div>
  );
}

export function LessonsScheduleVisual({ compact = false, caption = true }) {
  return (
    <ProductFigure
      className={`br-lessons-schedule ${compact ? "is-compact" : ""}`}
      label="BarnRelay Lessons monthly schedule showing recurring lessons across a week"
      caption={caption ? "Recurring lessons stay visible in the schedule where the lesson program is managed." : ""}
    >
      <ProductBar product="Lessons" view="Schedule" />
      <div className="br-schedule-heading">
        <div>
          <strong>Schedule</strong>
          <span>Monthly lesson assignment</span>
        </div>
        <b>September 2026</b>
      </div>
      <div className="br-calendar-grid">
        {lessonDays.map((item) => (
          <div className="br-calendar-day" key={item.day}>
            <span className="br-calendar-weekday">{item.day}</span>
            <span className="br-calendar-date">{item.date}</span>
            {item.lessons?.map((lesson, index) => (
              <span className="br-calendar-lesson" key={lesson}>
                <strong>{lesson}</strong>
                <small>{index === 0 ? "16:30–17:30" : index === 1 ? "17:30–18:30" : "18:30–19:30"}</small>
              </span>
            ))}
          </div>
        ))}
      </div>
    </ProductFigure>
  );
}

export function LessonsAttendanceVisual({ compact = false, caption = true }) {
  const students = [
    { name: "Avery Morgan", status: "attended" },
    { name: "Riley Chen", status: "expected" },
    { name: "Casey Brooks", status: "attended" },
  ];

  return (
    <ProductFigure
      className={`br-lessons-attendance ${compact ? "is-compact" : ""}`}
      label="BarnRelay Lessons detail showing lesson context, staff coverage, capacity, students, and attendance actions"
      caption={caption ? "The lesson detail keeps capacity, roster, attendance, make-up actions and relevant Staff coverage together." : ""}
    >
      <ProductBar product="Lessons" view="Lesson detail" />
      <div className="br-lesson-detail-head">
        <div>
          <strong>Wednesday Beginner</strong>
          <span>18:00–19:00 · Jordan Lee · Indoor Arena</span>
        </div>
        <div className="br-detail-actions">
          <button tabIndex="-1">Schedule make-up</button>
          <button tabIndex="-1">Record absence</button>
        </div>
      </div>
      <div className="br-coverage-panel">
        <div>
          <span className="br-ui-label">Staff coverage</span>
          <strong>No scheduled staff coverage for this lesson and role.</strong>
        </div>
      </div>
      <div className="br-capacity-row">
        <span>Capacity: <strong>4</strong></span>
        <span>Expected: <strong>3</strong></span>
        <span>Open slots: <strong>1</strong></span>
      </div>
      <div className="br-roster">
        <div className="br-roster-heading">
          <span>Regular students (3)</span>
          <span>Status</span>
          <span>Action</span>
        </div>
        {students.map((student) => (
          <div className="br-roster-row" key={student.name}>
            <strong>{student.name}</strong>
            <span className={`br-status br-status-${student.status}`}>{student.status}</span>
            <button tabIndex="-1">Record absence</button>
          </div>
        ))}
      </div>
    </ProductFigure>
  );
}

export function StaffScheduleVisual({ compact = false, caption = true }) {
  return (
    <ProductFigure
      className={`br-staff-schedule ${compact ? "is-compact" : ""}`}
      label="BarnRelay Staff weekly schedule showing helper coverage and selected shift details"
      caption={caption ? "Administrators can see where help is needed, what is covered and who has signed up." : ""}
    >
      <ProductBar product="Staff" view="Schedule" />
      <div className="br-staff-week">
        {staffDays.map((item) => (
          <div className="br-staff-day" key={item.day}>
            <strong>{item.day}</strong>
            <small>{item.date}</small>
            {item.shift ? (
              <span className="br-shift-card">
                <b>Lesson support</b>
                <small>16:00–19:00</small>
                <small>Instructor 1/1</small>
              </span>
            ) : (
              <span className="br-no-shifts">No shifts</span>
            )}
          </div>
        ))}
      </div>
      <div className="br-shift-detail">
        <div>
          <span className="br-ui-label">Selected shift</span>
          <strong>Lesson support · Sep 30</strong>
          <small>16:00–19:00 · Scheduled</small>
        </div>
        <dl>
          <div><dt>Role</dt><dd>Instructor</dd></div>
          <div><dt>Helper</dt><dd>Taylor Demo</dd></div>
          <div><dt>State</dt><dd>Checked in</dd></div>
        </dl>
      </div>
    </ProductFigure>
  );
}

function KioskCard({ state }) {
  const isOpen = state === "open";
  return (
    <div className="br-kiosk-card">
      <span className={`br-status ${isOpen ? "br-status-open" : "br-status-assigned"}`}>
        {isOpen ? "Open" : "Assigned"}
      </span>
      <strong>{isOpen ? "Arena Support" : "Lesson Support"}</strong>
      <span className="br-ui-label">{isOpen ? "Runner" : "Instructor"}</span>
      <b>{isOpen ? "08:00–10:00" : "15:30–18:00"}</b>
      {isOpen ? (
        <>
          <small>Hourly tracking</small>
          <label>
            Who are you?
            <span className="br-faux-select">Taylor Demo <b>⌄</b></span>
          </label>
          <button tabIndex="-1">Claim Runner · Arena Support</button>
        </>
      ) : (
        <>
          <small>Assigned helper: <b>Taylor Demo</b></small>
          <div className="br-kiosk-lesson">
            <span className="br-ui-label">Lessons during this shift</span>
            <b>16:00</b>
            <span>Beginner Lesson · Sample Arena</span>
          </div>
          <button tabIndex="-1">Mark me present · Taylor Demo</button>
        </>
      )}
    </div>
  );
}

export function StaffKioskVisual({ compact = false, caption = true }) {
  return (
    <ProductFigure
      className={`br-kiosk-visual ${compact ? "is-compact" : ""}`}
      label="BarnRelay Staff Kiosk showing an open shift to claim and an assigned shift with a presence action"
      caption={caption ? "Kiosk keeps the helper experience focused: choose an open shift, see what is coming up, and sign in when it is time to work." : ""}
    >
      <ProductBar product="Staff Kiosk" view="Shifts" />
      <div className="br-kiosk-heading">
        <div>
          <strong>Staff kiosk</strong>
          <span>Sample Riding School</span>
        </div>
        <span>Upcoming opportunities</span>
      </div>
      <div className="br-kiosk-grid">
        <KioskCard state="open" />
        <KioskCard state="assigned" />
      </div>
    </ProductFigure>
  );
}

export function ProductFamilyVisual() {
  return (
    <div
      className="br-family-visual"
      role="img"
      aria-label="BarnRelay Lessons and BarnRelay Staff shown as separate, focused applications in the same product family"
    >
      <div aria-hidden="true" className="br-family-layer br-family-lessons">
        <span className="br-family-label">BarnRelay Lessons</span>
        <div className="br-family-panel-heading">Wednesday Beginner</div>
        <div className="br-family-line is-long" />
        <div className="br-family-line" />
        <div className="br-family-stats">
          <span>Expected 3</span><span>Open 1</span>
        </div>
        <div className="br-family-roster"><span>Avery Morgan</span><b>attended</b></div>
        <div className="br-family-roster"><span>Riley Chen</span><b>expected</b></div>
      </div>
      <div aria-hidden="true" className="br-family-layer br-family-staff">
        <span className="br-family-label">BarnRelay Staff</span>
        <div className="br-family-panel-heading">Weekly schedule</div>
        <div className="br-family-week">
          <span /><span className="has-shift" /><span /><span className="has-shift" /><span />
        </div>
        <div className="br-family-shift"><b>Lesson support</b><small>16:00–19:00 · Instructor 1/1</small></div>
      </div>
      <div aria-hidden="true" className="br-family-layer br-family-kiosk">
        <span className="br-family-label">Staff Kiosk</span>
        <span className="br-status br-status-assigned">Assigned</span>
        <b>Lesson Support</b>
        <small>15:30–18:00</small>
        <button tabIndex="-1">Mark me present</button>
      </div>
    </div>
  );
}
